<template>
  <div class="myZone">
    <div class="head">
      <div class="infor">
        <div class="touxiang">
          <img
            :src="headData.headimg"
            alt=""
            v-show="!headData.headimg == ''"
          />
          <img
            src="../assets/images/nohead.png"
            alt=""
            v-show="headData.headimg == ''"
          />
          <div class="name">{{ headData.certname }}</div>
        </div>
        <div class="fabuNum">
          <div class="word">已发布</div>
          <div class="num">{{ listLength }}</div>
        </div>
      </div>
      <div class="bolangbg"></div>
    </div>
    <div class="myZoneContainer">
      <div class="noContent" v-if="noContent">
        <img src="../assets/images/kongjianNone.png" alt="" class="kjNone" />
        <div class="tishi">上传您的第一张动态吧</div>
        <div class="nowFabu" @click="goFabu">
          <img src="../assets/images/fabujiahao.png" alt="" />
          <div class="word">立即发布</div>
        </div>
      </div>
      <div class="waterfallList">
        <div class="leftList">
          <div
            class="Inlist"
            v-for="item in contentList1"
            :key="item.id"
            @click="goXiangqing(item.id)"
            :class="{ disabled: item.state == 1 || item.state == 3 }"
          >
            <div class="numIcon">
              <div class="numType">{{ item.picturecount }}</div>
            </div>
            <div class="img">
              <div class="state" v-show="item.state == 1">
                <div class="word">未审核</div>
              </div>
              <div class="state" v-show="item.state == 3">
                <div class="word">审核未通过</div>
              </div>

              <img :src="item.pictureurl" alt="" />
            </div>

            <div class="word">
              <div class="listContent">
                {{ item.content }}
              </div>
              <div class="listDibu">
                <div class="date">{{ item.createtime }}</div>
                <div class="hudong">
                  <div
                    class="dianzan pinglun"
                    @click="dianzan(item.dianzanNum)"
                  >
                    <img src="../assets/images/pinglun.png" alt="" />
                    <div class="dianzanNum">
                      {{ item.commentcount | filterNum }}
                    </div>
                  </div>
                  <div class="dianzan" @click="dianzan(item.dianzanNum)">
                    <img
                      src="../assets/images/dianzan1.png"
                      alt=""
                      v-show="
                        item.isFabulous == 0 ||
                        !item.hasOwnProperty('isFabulous')
                      "
                    />
                    <img
                      src="../assets/images/dianzan2.png"
                      alt=""
                      v-show="item.isFabulous == 1"
                    />
                    <div class="dianzanNum">
                      {{ item.fabulouscount | filterNum }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="rightList">
          <div
            class="Inlist"
            v-for="item in contentList2"
            :key="item.id"
            @click="goXiangqing(item.id)"
            :class="{ disabled: item.state == 1 || item.state == 3 }"
          >
            <div class="numIcon">
              <div class="numType">{{ item.picturecount }}</div>
            </div>
            <div class="img">
              <div class="state" v-show="item.state == 1">
                <div class="word">未审核</div>
              </div>
              <div class="state" v-show="item.state == 3">
                <div class="word">审核未通过</div>
              </div>

              <img :src="item.pictureurl" alt="" />
            </div>

            <div class="word">
              <div class="listContent">
                {{ item.content }}
              </div>
              <div class="listDibu">
                <div class="date">{{ item.createtime }}</div>
                <div class="hudong">
                  <div
                    class="dianzan pinglun"
                    @click="dianzan(item.dianzanNum)"
                  >
                    <img src="../assets/images/pinglun.png" alt="" />
                    <div class="dianzanNum">
                      {{ item.commentcount | filterNum }}
                    </div>
                  </div>
                  <div class="dianzan" @click="dianzan(item.dianzanNum)">
                    <img
                      src="../assets/images/dianzan1.png"
                      alt=""
                      v-show="
                        item.isFabulous == 0 ||
                        !item.hasOwnProperty('isFabulous')
                      "
                    />
                    <img
                      src="../assets/images/dianzan2.png"
                      alt=""
                      v-show="item.isFabulous == 1"
                    />
                    <div class="dianzanNum">
                      {{ item.fabulouscount | filterNum }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import { Dialog } from "vant";
import { Toast } from "vant";

export default {
  mounted() {

    this.getHeight();
    document.querySelector("body").setAttribute("style", "overflow:hidden;");
    this.getcontentList();
  },
  destroyed() {
    document.querySelector("body").setAttribute("style", "overflow:auto; ");
  },
  data() {
    return {
      isHasContent: true,
      noContent: false,
      contentList: [],
      certname: "",
      listLength: null,
      contentList1: [],
      contentList2: [],
      headData: Object,
    };
  },

  methods: {
    getToken() {
      let token = this.$route.query.token;
      localStorage.setItem("token", token);
    },
    goFabu() {
      this.$router.push("/Fabu");
    },
    goHudong() {
      this.$router.push("/");
    },
    getHeight() {
      let a = window.screen.availHeight;
      // console.log(a);
      let b =
        document.querySelector(".myZoneContainer").offsetTop -
        document.documentElement.scrollTop;
      // console.log(b);
      document.querySelector(".myZoneContainer").style.height = a - b + "px";
    },
    setDate(timespan) {
      let dateTime = new Date(timespan); // 将传进来的字符串或者毫秒转为标准时间
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let day = dateTime.getDate();
      let millisecond = dateTime.getTime(); // 将当前编辑的时间转换为毫秒
      let now = new Date(); // 获取本机当前的时间
      let nowyear = now.getFullYear();
      let nowNew = now.getTime(); // 将本机的时间转换为毫秒
      let milliseconds = 0;
      let timeSpanStr = "";
      milliseconds = nowNew - millisecond;
      if (milliseconds <= 1000 * 60 * 1) {
        // 小于一分钟展示为刚刚
        timeSpanStr = "刚刚";
      } else if (
        1000 * 60 * 1 < milliseconds &&
        milliseconds <= 1000 * 60 * 60
      ) {
        // 大于一分钟小于一小时展示为分钟
        timeSpanStr = Math.round(milliseconds / (1000 * 60)) + "分钟前";
      } else if (
        1000 * 60 * 60 * 1 < milliseconds &&
        milliseconds <= 1000 * 60 * 60 * 24
      ) {
        // 大于一小时小于一天展示为小时
        timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60)) + "小时前";
      } else if (
        1000 * 60 * 60 * 24 < milliseconds &&
        milliseconds <= 1000 * 60 * 60 * 24 * 3
      ) {
        // 大于一天小于三天展示为天
        timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60 * 24)) + "天前";
      } else if (year > nowyear) {
        timeSpanStr = month + "-" + day;
      } else {
        timeSpanStr = year + "-" + month + "-" + day;
      }
      return timeSpanStr;
    },
    goXiangqing(id) {
      this.$router.push({
        name: "FabuXiangqing",
        query: {
          id,
        },
      });

      // this.$router.push({
      //     name: "FabuXiangqing",
      //     query: {

      //     },
      //   });
      // }
    },
    getcontentList() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      this.$axios
        .post("appinteraction/user/appInteraction/getInteractionList")
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.headData = res.data;
            this.listLength = res.data.appInteractionList.length;
            if (res.data.appInteractionList.length == 0) {
              this.isHasContent = false;
              this.noContent = true;
              return;
            }
            if (res.data.appInteractionList.length !== 0) {
              res.data.appInteractionList.forEach((item) => {
                item.createtime = this.setDate(Number(item.createtime));
                if (item.content.length > 19) {
                  item.content = item.content.substring(0, 19) + "...";
                }
                this.contentList.push(item);
              });
              this.contentList1 = this.contentList.filter(
                (_item, index) => index % 2 === 0
              );
              this.contentList2 = this.contentList.filter(
                (_item, index) => index % 2 !== 0
              );
            }
            Toast.clear();
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    reOrder(arr, columns) {
      const cols = columns;
      const out = [];
      let col = 0;
      while (col < cols) {
        for (let i = 0; i < arr.length; i += cols) {
          let _val = arr[i + col];
          if (_val !== undefined) out.push(_val);
        }
        col++;
      }
      return out;
    },
  },
  filters: {
    filterNum: function (value) {
      if (Number(value) > 99) {
        return (value = "99+");
      } else {
        return value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  background-color: #ffffff;
  overflow: hidden;
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #eaeaea;
    font-size: 1.875rem;
    color: #19212a;

    .zuojian {
      position: absolute;
      top: 0;
      left: 2.125rem;
    }
  }
  .infor {
    display: flex;
    justify-content: space-between;
    padding: 0 3.125rem 0 2.125rem;
    margin-top: 3.5rem;
    z-index: 1000;
    .touxiang {
      display: flex;
      align-items: center;

      img {
        width: 7rem;
        height: 7rem;
      }
      .name {
        color: #19212a;
        font-size: 2.5rem;
        font-weight: bold;
        margin-left: 2rem;
      }
    }
    .fabuNum {
      display: flex;
      align-items: center;
      .word {
        color: #19212a;
        font-size: 1.75rem;
      }
      .num {
        color: #338989;
        font-weight: bold;
        font-size: 2.75rem;
        margin-left: 2rem;
      }
    }
  }
  .bolangbg {
    background-image: url("../assets/images/bolangbg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 46.875rem;
    height: 13rem;
  }
}

.myZoneContainer {
  height: auto;
  overflow: auto;
  background: #ffffff;
  padding: 2rem;
  border-radius: 1.5625rem;
  margin-top: -8.75rem;
}
.noContent {
  margin-top: 4.625rem;
  padding: 0 11.625rem;
  .kjNone {
    width: 17.375rem;
    height: 12.875rem;
  }
  .tishi {
    margin-left: -1.375rem;
    margin-top: 3rem;
    white-space: nowrap;
    font-size: 2.125rem;
    color: #19212a;
  }
  .nowFabu {
    display: flex;
    width: 23.75rem;
    height: 5.5rem;
    margin-left: -2rem;
    margin-top: 3.875rem;
    align-items: center;
    justify-content: center;
    border: 1px solid #338989;
    border-radius: 2.75rem;

    img {
      width: 2rem;
      height: 2rem;
    }
    .word {
      font-size: 2rem;
      color: #338989;
      white-space: nowrap;
      margin-left: 1rem;
    }
  }
}
.waterfallList {
  display: flex;
  justify-content: space-between;
  .leftList {
    width: 47.5%;
    display: flex;
    flex-direction: column;
  }
  .rightList {
    width: 47.5%;
    display: flex;
    flex-direction: column;
  }
}

.Inlist {
  margin: 0 0 2rem 0;
  position: relative;
  font-size: 1.75rem;
  color: #19212a;
  .numIcon {
    position: absolute;
    width: 2.75rem;
    height: 2.75rem;
    background: rgba(0, 0, 0, 0.85);
    border-radius: 25rem;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 1.375rem;
    right: 1.625rem;
    font-size: 1.5rem;
    z-index: 100;
  }
}
.Inlist .img img {
  width: 100%;
  margin-bottom: 0.625rem;
  border-radius: 1rem;
}
.Inlist .img {
  position: relative;
  .state {
    width: 50%;
    height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 1.75rem;
    color: #ffffff;
    transform: translateX(-50%) translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;

    white-space: nowrap;
    background: #338989;
    border-radius: 50%;
  }
}

.word {
  .listContent {
    padding: 0 0.375rem;
    font-size: 1.75rem;
    color: #19212a;
    letter-spacing: 1px;
  }
  .listDibu {
    display: flex;
    align-items: center;
    margin-top: 0.875rem;
    .date {
      font-size: 1.5rem;
      white-space: nowrap;
      color: #878787;
    }
  }

  .hudong {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.5rem;
    color: #878787;

    .pinlun {
      display: flex;
      align-items: center;
      margin-left: 7rem;

      img {
        width: 2.125rem;
      }
    }
    .dianzan {
      display: flex;
      align-items: center;
      margin-left: 2rem;
      img {
        width: 2.125rem;
      }
      .dianzanNum {
        font-size: 1.5rem;
      }
    }
    .pinglun {
      .dianzanNum {
        margin-left: 0.25rem;
      }
      img {
        width: 1.625rem;
      }
    }
  }
}
.disabled {
  pointer-events: none;
}
</style>